import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  defaultMapLocation,
  type Location,
  type Coordinates,
} from '~/utilities';

export interface LocationState {
  value?: Location;
}

export const initialState: LocationState = {
  value: undefined, // Will be set for squamish after feature flags load
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    clearLocation: (state) => (state.value = undefined),
    setLocation: (state, action: PayloadAction<Location | undefined>) => {
      state.value = action.payload;
    },
    //for squamish only, can be removed after nvan launch
    initializeDefaultLocation: (state) => {
      state.value = defaultMapLocation;
    },
    setLocationCoordinates: (state, action: PayloadAction<Coordinates>) => {
      if (state.value) {
        state.value.coordinates = action.payload;
      }
    },
    resetLocation: (state) => {
      state.value = undefined;
    },
  },
});

type SliceState = { location: LocationState };
export const selectLocation = (state: SliceState) => state.location.value;
export const {
  clearLocation,
  setLocation,
  initializeDefaultLocation,
  setLocationCoordinates,
  resetLocation,
} = locationSlice.actions;
export default locationSlice.reducer;
